module.exports = __webpack_public_path__ + "img/iku nagae_sc1.e67fb162.png";